module.exports = __webpack_public_path__ + "img/CompanyNotFound.e618a926.png";